// @flow
import defaultState from '../defaultState';
import type { CurrentCampaignActions as Action } from '../types';

const defaultCurrentCampaign = defaultState.currentCampaign;

export default function currentCampaign(
  state: any = defaultCurrentCampaign,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_CAMPAIGN':
      return {
        ...action.campaign.campaign,
        settings: { ...action.campaign.settings }
      };

    case 'UPDATE_CURRENT_CAMPAIGN_SETTINGS':
      return {
        ...state,
        settings: action.settings
      };

    case 'UPDATE_CURRENT_CAMPAIGN_STEP':
      return {
        ...state,
        statusTypeId: action.statusTypeId
      };

    case 'CLEAR_CURRENT_CAMPAIGN':
      return defaultCurrentCampaign;

    case 'LOGOUT':
      return defaultCurrentCampaign;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentCampaign.js